import * as Yup from "yup";

const objectIdValidator = Yup.string()
  .trim()
  .matches(/^[0-9a-fA-F]{24}$/, "Invalid ObjectId");

export const customerGroupCreateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(1, "Group name should have at least 1 character.")
    .max(100, "Group name should have at most 100 characters.")
    .required("Group name is required."),

  customers: Yup.array()
    .of(objectIdValidator)
    .required("Customer IDs are required for customer groups.")
    .min(1, "At least one customer ID is required."),
});

export const supplierGroupCreateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(1, "Group name should have at least 1 character.")
    .max(100, "Group name should have at most 100 characters.")
    .required("Group name is required."),

  suppliers: Yup.array()
    .of(objectIdValidator)
    .required("Supplier IDs are required for supplier groups.")
    .min(1, "At least one supplier ID is required."),
});

export const groupUpdateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(1, "Group name should have at least 1 character.")
    .max(100, "Group name should have at most 100 characters."),
});

export const addCustomersAndSuppliersToExistingGroupValidationSchema =
  Yup.object().shape({
    users: Yup.array()
      .of(objectIdValidator)
      .required("User IDs are required.")
      .min(1, "At least one user ID is required."),
  });
